import {KJUR} from 'jsrsasign';
import {
    JwtClaimVerifyOptions,
    KeyLike,
    VerifyOptions,
    JwtVerifyResult,
    JwtPayload,
    JwsHeaderParameters
} from '../types.ts';
import {JwsInvalid} from '../errors.ts';

export interface JwtVerifyOptions extends  VerifyOptions, JwtClaimVerifyOptions {

}

function arrayWrap(value?: string | string[]) {
    if (typeof value === 'string') {
        return [value];
    }
    if (Array.isArray(value)) {
        return value;
    }
}

export function jwtVerify<PayloadType = JwtPayload>(jwt: string, key: KeyLike | ((jwksUri: JwsHeaderParameters) => Promise<KeyLike>), options?: JwtVerifyOptions): Promise<JwtVerifyResult<PayloadType>> | JwtVerifyResult<PayloadType> {
    const {headerObj: protectedHeader, payloadObj: payload} = KJUR.jws.JWS.parse(jwt)
    const acceptField = {
        alg: options?.algorithms ?? [protectedHeader.alg],
        aud: arrayWrap(options?.audience),
        iss: arrayWrap(options?.issuer),
        sub: arrayWrap(options?.subject),
        gracePeriod: options?.clockTolerance
    };
    if (typeof key === 'function') {
        return key(protectedHeader as JwsHeaderParameters)
            .then((resolvedKey) => KJUR.jws.JWS.verifyJWT(jwt, resolvedKey, acceptField))
            .then((valid) => {
                if (!valid) {
                    throw new JwsInvalid();
                }
                return {
                    payload: payload as PayloadType,
                    protectedHeader
                };
            });
    }
    if (KJUR.jws.JWS.verifyJWT(jwt, key, acceptField)) {
        return {
            payload: payload as PayloadType,
            protectedHeader
        };
    }
    throw new JwsInvalid();
}
